import * as React from "react";
import type { SVGProps } from "react";
const ClothingStore = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4362_3987)">
      <path
        fill="currentColor"
        d="M8.2808 3c.2681 0 .4916.196.574.4537.4229 1.3304 1.6707 2.2963 3.1454 2.2963s2.7225-.966 3.1453-2.2962c.0825-.2579.3059-.4538.5741-.4538h.4331c.7734 0 1.5194.2716 2.1141.7666l4.3381 3.6128c.2269.189.3678.464.3919.7597a1.094 1.094 0 0 1-.2682.8112l-1.925 2.2c-.3918.4503-1.0725.5019-1.5331.1203l-1.7703-1.4747V18.4c0 1.2134-.9866 2.2-2.2 2.2h-6.6c-1.2134 0-2.2-.9866-2.2-2.2V9.796l-1.7703 1.4746c-.4572.3816-1.1378.33-1.5331-.1203l-1.925-2.2a1.094 1.094 0 0 1-.2682-.8112c.024-.2957.165-.5707.392-.7597l4.338-3.6128A3.302 3.302 0 0 1 7.8476 3z"
      />
    </g>
    <defs>
      <clipPath id="clip0_4362_3987">
        <path fill="transparent" d="M1 3h22v17.6H1z" />
      </clipPath>
    </defs>
  </svg>
);
export default ClothingStore;
